import React from 'react'
import AdminForm from './admin-form'
import CareersForm from './careers-form'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const Careers = ({title, admin}) => {
  return (
    <>
      <section className="contact contact--careers" id="apply">
        <Fade distance='40px' bottom>
          <div className="contact__inner">
            { title && <div className="contact__title"><h2>{parse(title)}</h2></div> }
            <div className='contact__content' />
            <div className="contact__form">
              { admin 
                ? <AdminForm /> 
                : <iframe src="https://jobs.atollon.com.au" scrolling="no" style={{width: '100%', height: '1250px', border: 'none', overflow: 'hidden'}} />
              }
            </div>
          </div>
        </Fade>
      </section>
    </>
  );
};

export default Careers